import Env from '../config/envConfig'

import {
  ImprintApi as ImprintApiClass,
  Configuration,
} from '@professocialApi/professocial-core-frontend-api'
import customFetchApi from './customFetchApi'
import {
  FacebookPageApi as FacebookPageApiClass,
  MediaFileApi as MediaFileApiClass,
  Configuration as SMConfiguration,
} from '@3m5/sm_publish-frontend-api'
import smModuleFetchApi from './smModuleFetchApi'

const BASE_PATH_API = Env.restBase

export const ImprintApi = new ImprintApiClass(new Configuration({
  basePath: BASE_PATH_API,
  fetchApi: customFetchApi(fetch),
}))

export const FacebookPageApi = new FacebookPageApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))

export const MediaFileApi = new MediaFileApiClass(new SMConfiguration({
  basePath: BASE_PATH_API,
  fetchApi: smModuleFetchApi(fetch),
}))
